import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import ProductForm from "../../components/ProductFrom";
import ProductList from "../../components/ProductList";

export default function Products() {
    const { setPageTitle, setPageUserID } = useAppContext();
    const [editMode, setEditMode] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        setPageUserID(null);
        setPageTitle("Products");
    }, [setPageTitle, setPageUserID]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            {
                                !editMode ? (
                                    <ProductList setEditMode={setEditMode} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct}  />
                                ) : (
                                    <ProductForm setEditMode={setEditMode} product={selectedProduct} />
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}